<template>
  <div class="timer-component" :class="timerClass">
    <div class="timer-display">
      <div class="time-remaining">{{ formattedTime }}</div>
      <div class="timer-label">Time Remaining</div>
    </div>
    
    <div class="timer-controls">
      <button 
        v-if="!isPaused"
        @click="$emit('timer-pause')"
        class="timer-btn pause-btn"
        title="Pause timer"
      >
        ⏸️ Pause
      </button>
      <button 
        v-else
        @click="$emit('timer-resume')"
        class="timer-btn resume-btn"
        title="Resume timer"
      >
        ▶️ Resume
      </button>
    </div>
    
    <div class="timer-progress">
      <div 
        class="timer-progress-bar"
        :style="{ width: progressPercentage + '%' }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    timeRemaining: Number,
    totalTime: Number,
    isPaused: Boolean
  },
  
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.timeRemaining / 60);
      const seconds = this.timeRemaining % 60;
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
    
    progressPercentage() {
      return (this.timeRemaining / this.totalTime) * 100;
    },
    
    timerClass() {
      if (this.timeRemaining < 60) return 'timer-critical';
      if (this.timeRemaining < 180) return 'timer-warning';
      return 'timer-normal';
    }
  }
}
</script>

<style scoped>
.timer-component {
  padding: 20px;
  background: white;
  border-bottom: 1px solid #e9ecef;
}

.timer-display {
  text-align: center;
  margin-bottom: 10px;
}

.time-remaining {
  font-size: 2em;
  font-weight: 700;
  font-family: 'Courier New', monospace;
  line-height: 1;
}

.timer-label {
  font-size: 0.9em;
  color: #6c757d;
  margin-top: 4px;
}

.timer-controls {
  text-align: center;
  margin-bottom: 10px;
}

.timer-btn {
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 0.9em;
  cursor: pointer;
}

.timer-btn:hover {
  background: #0056b3;
}

.timer-progress {
  height: 6px;
  background: #e9ecef;
  border-radius: 3px;
  overflow: hidden;
}

.timer-progress-bar {
  height: 100%;
  background: #28a745;
  transition: width 1s linear, background-color 0.3s ease;
}

/* Timer state styles */
.timer-normal .timer-progress-bar {
  background: #28a745;
}

.timer-warning .timer-progress-bar {
  background: #ffc107;
}

.timer-critical .timer-progress-bar {
  background: #dc3545;
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}
</style>